import { RootState } from "../store";

export const popupSelect = (state: RootState) => state.popupReducer;
